import { Injectable } from '@angular/core';
declare var Goftino: any;

@Injectable({
  providedIn: 'root',
})
export class GoftinoService {
  constructor() {}

  setGoftinoUser(email: string, name: string, phone: string) {
    window.addEventListener('goftino_ready', function () {
      Goftino.setUser({
        email: email,
        name: name,
        phone: phone,
        forceUpdate: true,
      });
    });
  }
}
